// extracted by mini-css-extract-plugin
export default {"bg":"Game_bg__X7BO7"};